'use strict';

export class MonthlyGiving {
    #monthly_giving_modal;
    #monthly_giving_modal_close_button;
    #donation_frequency_inputs;

    constructor() {
        this.#monthly_giving_modal = document.querySelector('.monthly-giving-modal');
        this.#monthly_giving_modal_close_button = document.querySelector('.monthly-giving-modal a.close');
        this.#donation_frequency_inputs = document.querySelectorAll('input[name="donation_frequency"]');

        this.addEvents();
    }

    addEvents() {
        if(this.#monthly_giving_modal_close_button) {
            this.#monthly_giving_modal_close_button.addEventListener('click', (event) => {
                event.preventDefault();
                if(this.#monthly_giving_modal) {
                    this.#monthly_giving_modal.classList.remove('active')
                }
            })
        }
        if(this.#donation_frequency_inputs.length) {
            Array.from(this.#donation_frequency_inputs).forEach((input)=>{
               input.addEventListener('change', (event) => {
                  if(event.target.value === 'monthly') {
                      if(this.#monthly_giving_modal) {
                          this.#monthly_giving_modal.classList.add('active')
                      }
                  }
               });
            });
        }
    }
}